import Swal from 'sweetalert2';
import $http from '../../../axios-instance';
import $http_wor from '../../../axios-instance-wor';
import $http_ari from '../../../axios-instance-ari';

/**
 * Obtener las tareas
 */
export async function obtenerTareas({commit, state}) {
    commit('dashboard/load', true, {root: true});

    await $http_ari.get('analisis-de-riesgos/tareas', {params: state.filtros})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('establecerTareas', response.data.data);
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Metodo que pagina todos los analisis.
 *
 * @param {*} perPage numero de analisis por pagina.
 * @return {Array}
 */
export async function getPerPageAnalysis({commit, dispatch}, perPage) {
    commit('setPerPageAnalysis', parseInt(perPage));
    await dispatch('obtenerTareas');
}

/**
 * Metodo que cambia de pagina en el tag de analisis.
 *
 * @param {*} page pagina analisis.
 * @return {Array}
 */
export async function setPageAnalysis({commit, dispatch}, page) {
    commit('setPageAnalysis', parseInt(page));
    await dispatch('obtenerTareas');
}

/**
 * Descargar excel
 */
export async function descargarExcel({state, commit}) {
    if (!!state.filtros.id_empresa) {

        commit('setIdsFiltro');

        const empresa = state.empresas_filtro.find(e => e.id === state.filtros.id_empresa);

        let nombre_archivo = 'TAREAS_' + empresa.nombre;

        if (state.filtros.fechas && state.filtros.fechas[0]) {
            nombre_archivo += '_' + state.filtros.fechas[0] + '_' + state.filtros.fechas[1];
        }

        nombre_archivo += '.xlsx';

        commit('dashboard/load', true, {root: true});

        await $http_ari({
            url: 'analisis-de-riesgos/tareas/descargar',
            params: state.filtros,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            window.downloadFile(response.data, nombre_archivo);
            commit('dashboard/load', false, {root: true});
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
        });

    }
}

/**
 * Obtener la tarea
 */
export async function obtenerTarea({commit, state}, {id, id_empresa}) {
    commit('dashboard/load', true, {root: true});
    await $http_ari.get('analisis-de-riesgos/tareas/' + id + '?id_empresa=' + id_empresa)
        .then((response) => {
            commit('establecerTarea', response.data.data);
            commit('establecerEmpresas', [response.data.data.company]);
            if (response.data.data.manufacturer) {
                commit('establecerFabricantes', [response.data.data.manufacturer]);
            }
            commit('establecerProductos', [response.data.data.product]);
            commit('dashboard/load', false, {root: true});
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear tarea
 */
export async function crearTarea({commit, state}) {
    return await new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});
        await $http_ari.post('analisis-de-riesgos/tareas', state.tarea)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                commit('limpiarTarea');
                commit('establecerResultado', response.data.data);
                resolve(response.data.task);
            }).catch((error) => {
                commit('dashboard/load', false, {root: true});
                reject(error);
            });
    });
}

/**
 * Actualizar tarea
 */
export async function actualizarTarea({commit, state}) {
    return await new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});
        await $http_ari.put('analisis-de-riesgos/tareas/' + state.tarea.id, state.tarea)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                commit('establecerResultado', response.data.data);
                resolve();
            }).catch((error) => {
                commit('dashboard/load', false, {root: true});
                reject(error);
            });
    });
}

/**
 * Eliminar tarea
 */
export async function eliminarTarea({commit, state, dispatch}, tarea) {
    return await new Promise(async (resolve, reject) => {
        Swal.fire({
            title: 'Eliminar tarea',
            text: '¿Está seguro de eliminar la tarea ' + tarea.tarea + ' ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Eliminar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                commit('dashboard/load', true, {root: true});
                await $http_ari.delete('analisis-de-riesgos/tareas/' + tarea.id + '?id_empresa=' + tarea.id_empresa)
                    .then((response) => {
                        commit('dashboard/load', false, {root: true});
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: response.data.mensaje,
                            showConfirmButton: false,
                            timer: 2000
                        });
                        dispatch('obtenerTareas');
                        resolve(response);
                    }).catch((error) => {
                        commit('dashboard/load', false, {root: true});
                        reject(error);
                    });
            }
        });
    });
}

/**
 * Descargar plantilla
 */
export async function downloadControlSheet({commit}, tarea) {

    commit('dashboard/load', true, {root: true});

    await $http_ari({
        url: 'fichas-control/descargar/' + tarea.id + '/' + tarea.id_empresa,
        method: 'GET',
        responseType: 'blob'
    })
        .then(response => {
            commit('dashboard/load', false, {root: true});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Ficha de control.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            commit('dashboard/load', false, {root: true});
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

/**
 * Descargar analisis
 */
export async function downloadAnalysis({commit}, tarea) {

    commit('dashboard/load', true, {root: true});

    await $http_ari({
        url: 'analisis/descargar/' + tarea.id + '/' + tarea.id_empresa,
        method: 'GET',
        responseType: 'blob'
    })
        .then(response => {
            commit('dashboard/load', false, {root: true});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Análisis de tarea.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            commit('dashboard/load', false, {root: true});
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

/**
 * Obtener empresas
 */
export async function obtenerEmpresas({dispatch, commit, state}, nombre) {
    if (nombre.length >= 3) {
        dispatch('obtenerEmpresasPeticion', nombre)
            .then(empresas => commit('establecerEmpresas', empresas));
    }
}

/**
 * Obtener empresas filtro
 */
export async function obtenerEmpresasFiltro({commit, dispatch}, nombre) {
    dispatch('obtenerEmpresasPeticion', nombre)
        .then(empresas => commit('establecerEmpresasFiltro', empresas));
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerEmpresasPeticion({commit, state}, nombre) {

    return await new Promise(async (resolve, reject) => {
        if (!state.cargando_datos_select && nombre && nombre.length > 1) {
            commit('establecerCargandoDatosSelect', true);

            let parametros = {
                params: {
                    nombre: nombre
                }
            };

            commit('dashboard/load', true, {root: true});

            await $http.get('/empresas/lista', parametros)
                .then((response) => {
                    localStorage.setItem('empresas', JSON.stringify(response.data.data));
                    commit('dashboard/load', false, {root: true});
                    commit('establecerEmpresasFiltro', response.data.data)
                    resolve(response.data.data);
                    commit('establecerCargandoDatosSelect', false);
                })
                .catch(() => {
                    commit('dashboard/load', false, {root: true});
                    console.warn('No se encontraron empresas con el nombre especificado');
                    reject([]);
                    commit('establecerCargandoDatosSelect', false);
                });
        }
    });
}

/**
 * Obtener Ubicaciones de acuerdo al id de una empresa
 */
export async function obtenerUbicaciones({commit}, id_empresa) {

    if (id_empresa) {

        commit('dashboard/load', true, {root: true});
        await $http.get(`company/location/tree/${id_empresa}`)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerUbicaciones', response.data.data);
            }).catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener Ubicaciones de acuerdo al id de una empresa
 */
export async function obtenerUbicacionesFiltro({commit}, id_empresa) {

    commit('establecerIdUbicacionFiltro', []);

    if (id_empresa) {
        commit('dashboard/load', true, {root: true});
        await $http.get(`company/location/tree/${id_empresa}`)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerUbicacionesFiltro', response.data.data);
            }).catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener fabricantes
 */
export async function obtenerFabricantes({dispatch, commit}, nombre) {
    dispatch('obtenerFabricantesPeticion', nombre)
        .then(fabricantes => commit('establecerFabricantes', fabricantes));
}

/**
 * Obtener fabricantes
 */
export async function obtenerFabricantesFiltro({dispatch, commit}, nombre) {
    dispatch('obtenerFabricantesPeticion', nombre)
        .then(fabricantes => commit('establecerFabricantesFiltro', fabricantes));
}

/**
 * Obtener fabricantes desde el back
 */
export async function obtenerFabricantesPeticion({commit, state}, nombre) {

    return await new Promise(async (resolve, reject) => {
        if (!state.cargando_datos_select && nombre && nombre.length > 1) {
            commit('establecerCargandoDatosSelect', true);

            let parametros = {
                params: {
                    nombre: nombre
                }
            };
            commit('dashboard/load', true, {root: true});
            await $http.get('/fabricantes', parametros)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.fabricantes);
                    commit('establecerCargandoDatosSelect', false);
                })
                .catch(() => {
                    commit('dashboard/load', false, {root: true});
                    console.warn('No se encontraron fabricantes con el nombre especificado');
                    reject([]);
                    commit('establecerCargandoDatosSelect', false);
                });
        }
    });
}

/**
 * Obtener productos
 */
export async function obtenerProductos({dispatch, commit, state}, nombre) {

    let parametros = {
        nombre: nombre,
        id_fabricante: state.tarea.id_fabricante
    };

    dispatch('obtenerProductosPeticion', parametros)
        .then(productos => commit('establecerProductos', productos));
}

/**
 * Obtener productos filtro
 */
export async function obtenerProductosFiltro({dispatch, commit, state}, nombre) {

    let parametros = {
        nombre: nombre,
        id_fabricante: state.filtros.id_fabricante
    };

    dispatch('obtenerProductosPeticion', parametros)
        .then(productos => commit('establecerProductosFiltro', productos));
}

/**
 * Obtener fabricantes desde el back
 */
export async function obtenerProductosPeticion({commit, state, rootState}, {nombre, id_fabricante}) {

    return await new Promise(async (resolve, reject) => {
        if (!state.cargando_datos_select && nombre && nombre.length > 1) {
            commit('establecerCargandoDatosSelect', true);

            let parametros = {
                params: {
                    nombre: nombre,
                    id_fabricante: id_fabricante
                }
            };

            commit('dashboard/load', true, {root: true});

            await $http_ari.get('/productos-por-fabricante', parametros)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                    commit('establecerCargandoDatosSelect', false);
                })
                .catch(() => {
                    commit('dashboard/load', false, {root: true});
                    console.warn('No se encontraron fabricantes con el nombre especificado');
                    reject([]);
                    commit('establecerCargandoDatosSelect', data);
                });
        }
    });
}

/**
 * Obtener componentes de acuerdo al id de un producto
 */
export async function obtenerComponentes({commit, state, rootState}, id_producto) {

    if (!rootState.dashboard.loading) {
        commit('establecerComponentes', []);
    }

    if (id_producto) {
        commit('dashboard/load', true, {root: true});
        await $http.get('cas/listar-componente-producto-tlv/' + id_producto)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerComponentes', response.data);
            }).catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener categorías de acuerdo al id de un producto
 */
export async function obtenerCategorias({commit, state, rootState}, id_producto) {

    if (!rootState.dashboard.loading) {
        commit('establecerCategorias', []);
    }

    if (id_producto) {
        commit('dashboard/load', true, {root: true});
        await $http_ari.get('adm_productos/sga/' + id_producto)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerCategorias', response.data.data);
                commit('establecerCategoriasSga', response.data.categories);
            }).catch((e) => {
                console.log(e);
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener usuarios
 */
export async function obtenerUsuarios({commit}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('usuarios/responsables')
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('establecerUsuarios', response.data.data);
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener cargos
 */
export async function obtenerCargos({state, commit}, id_empresa) {

    if (id_empresa) {
        let parametros = {
            id_empresa: id_empresa
        };
        commit('dashboard/load', true, {root: true});

        await $http_ari.get('/cargos', {params: parametros})
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerCargos', response.data.data);
            }).catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener ges
 */
export async function obtenerGes({state, commit}, id_empresa) {
    if (id_empresa) {
        let parametros = {
            id_empresa: id_empresa
        };

        commit('dashboard/load', true, {root: true});

        await $http_ari.get('/ges', {params: parametros})
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerGes', response.data.data);
            }).catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

export async function obtenerUnidadesDeTemperatura({state, commit, dispatch}) {
    let control = state.controls.find(c => c.codigo === 'UTEMP');
    if (control) {
        commit('establecerUnidadesDeTemperatura', control.listas);
    }
}

export async function obtenerCapacidades({state, commit, dispatch}) {
    let control = state.controls.find(c => c.codigo === 'CAPA');
    if (control) {
        commit('establecerCapacidades', control.listas);
    }
}

export async function obtenerOpcionesDeFrecuencia1({state, commit, dispatch}) {
    let control = state.controls.find(c => c.codigo === 'OFR1');
    if (control) {
        commit('establecerOpcionesDeFrecuencia1', control.listas);
    }
}

export async function obtenerOpcionesDeFrecuencia2({state, commit, dispatch}) {
    let control = state.controls.find(c => c.codigo === 'OFR2');
    if (control) {
        commit('establecerOpcionesDeFrecuencia2', control.listas);
    }
}


export async function obtenerViasDeIngreso({state, commit, dispatch}) {
    let control = state.controls.find(c => c.codigo === 'VING');
    console.log(control);
    if (control) {
        commit('establecerViasDeIngreso', control.listas);
    }
}


export async function obtenerSuperficiesExpuestas({state, commit, dispatch}) {
    let control = state.controls.find(c => c.codigo === 'SEXP');
    if (control) {
        commit('establecerSuperficiesExpuestas', control.listas);
    }
}

export async function obtenerClasesDeProcedimiento({state, commit, dispatch}) {
    let control = state.controls.find(c => c.codigo === 'CLPR');
    if (control) {
        commit('establecerClasesDeProcedimiento', control.listas);
    }
}

export async function obtenerClasesDePulverulencia({state, commit, dispatch}) {
    let control = state.controls.find(c => c.codigo === 'CPUL');
    if (control) {
        commit('establecerClasesDePulverulencia', control.listas);
    }
}


export async function obtenerUnidadesDeMedidaTlv({state, commit, dispatch}) {
    let control = state.controls.find(c => c.codigo === 'UMTLV');
    if (control) {
        commit('establecerUnidadesDeMedidaTlv', control.listas);
    }
}

/**
 * Obtener Listas por el código del control
 */
export async function obtenerListasPorCodigoControl({commit}, codigo) {
    return new Promise(async (resolve) => {
        if (codigo) {
            commit('dashboard/load', true, {root: true});
            await $http.get(`/adm_general/listas/codigo-control/${codigo}`)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                }).catch(() => {
                    commit('dashboard/load', false, {root: true});
                    resolve([]);
                });
        } else {
            resolve([]);
        }
    });
}

/**
 * Obtener ges
 */
export async function establecerIdComponente({rootState, state, commit, dispatch}, id_componente) {

    const componente = state.componentes.find(c => c.prod_component_id === id_componente);

    commit('establecerTlv', 1);
    commit('establecerIdUnidadMedidaTlv', null);

    if (componente && componente.acgihtwa) {
        commit('establecerTlv', componente.acgihtwa);
        state.unidades_de_medida_tlv.map(um => {
            if (um.lista === componente.lista) {
                commit('establecerIdUnidadMedidaTlv', um.id);
            }
        });
    }

    state.componentes.map(c => {
        c.select = c.prod_component_id === id_componente;
    });

    commit('establecerIdComponente', id_componente);
}

export function esNumero(n) {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
}

/**
 * Obtener las propiedades de un producto
 */
export async function obtenerPropiedades({commit, rootState}, id_producto) {

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('propiedades-productos/' + id_producto)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('establecerPropiedades', response.data.propiedades);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Enviar propiedades de un producto.
 */
export async function guardarPropiedades({commit, state, rootState, dispatch}, id_producto) {

    commit('establecerIdProductoEnPropiedades', id_producto);

    commit('dashboard/load', true, {root: true});
    await $http_ari.post('propiedades-productos', state.propiedades).then(async (response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: true,
            timer: 3000
        });
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 3000
        });
    });
}

/**
 * Obtener la empresa asociada desde el back
 *
 * @param nombre
 * @return empresas backend
 * @author Paul
 */
export async function getMyCompanyPetition({commit}) {

    return await new Promise(async (resolve, reject) => {
        await $http.get('/mi-empresa/lista')
            .then((response) => {
                resolve(response.data);
            })
            .catch(() => {
                reject([]);
            });
    });
}

/**
 * Obtener la empresa asociada del usuario.
 */
export async function getMyCompany({commit, dispatch}) {
    const companies = await dispatch('getMyCompanyPetition');
    if (companies.length) {
        commit('establecerEmpresas', companies);
        commit('establecerEmpresasFiltro', companies);
        return Promise.resolve(companies[0]);
    }
}

/**
 * Obtener la empresa asociada del usuario.
 */
export async function getTasksByCharts({commit, dispatch}, payload) {
    commit('dashboard/load', true, {root: true});
    await $http_ari.get('analisis-de-riesgos/graficos', {params: payload}).then(async (response) => {
        commit('dashboard/load', false, {root: true});
        commit('setInfoCharts', response.data);
        if (!response.data.tasks.length) {
            await Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'No se encontro información',
                showConfirmButton: false,
                timer: 3000
            });
        }
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 3000
        });
    });
}

/**
 * Obtener tareas.
 */
export async function fetchTasks({state, commit}) {

    let params = {
        paginate: 0
    };

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('tasks/' + state.tarea.id_empresa, {params})
        .then(async (response) => {
            commit('setTasks', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener cargos.
 */
export async function fetchPositions({state, commit}, task_id = null) {

    let params = {
        paginate: 0,
        task_id: task_id
    };

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('positions/' + state.tarea.id_empresa, {params})
        .then(async (response) => {
            commit('setPositions', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener hygienic_measurements.
 */
export async function fetchHygienicMeasurements({state, commit}) {

    let params = {
        paginate: 0
    };

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('hygienic-measurements/' + state.tarea.id_empresa, {params})
        .then(async (response) => {
            commit('setHygienicMeasurements', response.data.data);
            commit('addDefaultHygienicMeasurements');
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('addDefaultHygienicMeasurements');
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener Trabajadores.
 */
export async function fetchWorkers({state, commit}) {

    if (!state.tarea.fecha || !state.tarea.wor_position_id) {
        return;
    }

    let params = {
        paginate: 0,
        date: state.tarea.fecha,
        position_id: state.tarea.wor_position_id
    };
    commit('dashboard/load', true, {root: true});

    await $http_wor.get('workers/' + state.tarea.id_empresa, {params})
        .then(async (response) => {
            commit('setWorkers', response.data.data);
            commit('dashboard/load', false, {root: true});

        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Consultar controles por códigos.
 */
export async function getControls({state, commit, dispatch}) {

    const params = {
        codes: [
            'UTEMP',
            'CAPA',
            'OFR1',
            'OFR2',
            'VING',
            'SEXP',
            'CLPR',
            'CPUL',
            'UMTLV'
        ]
    };

    commit('dashboard/load', true, {root: true});

    await $http.post(`/adm_general/listas/codigos-control`, params)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setControls', response.data.data);
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}


/**
 * Obtener Trabajadores.
 */
export async function getWorkers({state, commit}) {

    if (!state.tarea.fecha || !state.tarea.wor_position_id) {
        return;
    }

    let params = {
        paginate: 0,
        date: state.tarea.fecha,
        position_id: state.tarea.wor_position_id
    };
    commit('dashboard/load', true, {root: true});

    await $http_wor.get('worker/list-actives-by-company/' + state.tarea.id_empresa, {params})
        .then(async (response) => {
            commit('setWorkers', response.data.data);
            commit('dashboard/load', false, {root: true});

        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}



export async function getPositions({state, commit}, task_id = null) {

    let params = {
        paginate: 0,
        task_id: task_id
    };

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('worker/positions/' + state.tarea.id_empresa, {params})
        .then(async (response) => {
            commit('setPositions', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener empresas por ids.
 *
 * @param companies_ids
 */
export async function getCompaniesByIds({state, commit},companies_ids) {
    commit('dashboard/load', true, {root: true});
    await $http.get('companies/list-by-ids', {params: {companies_ids}})
        .then(async (response) => {
            commit('establecerEmpresas', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener empresas por ids.
 *
 * @param companies_ids
 */
export async function getProductById({state, commit},product_id) {
    commit('dashboard/load', true, {root: true});
    await $http_ari.get('/productos-por-fabricante', {params: {product_id}})
        .then(async (response) => {
            commit('establecerProductos', response.data.data)
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        }).finally(() =>  commit('dashboard/load', false, {root: true}))


}
